module.exports = __webpack_public_path__ + "static/media/contacto.0fd84bc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vector/contacto.svg
// module id = 174
// module chunks = 0